import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {User} from '../../models/user.model';
import {UserService} from '../../services/user.service';
import {Response} from '@angular/http';
import {FullUser} from '../../models/full-user.model';
import {TimeFormatterService} from '../../services/time-formatter.service';

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.css']
})
export class MyProfileComponent implements OnInit {
  private user: User;
  userAPI;
  public isLoaded = false;
  public errorInfo = false;
  isAdmin = false;
  host;
  isAdmins = false;
	isUser = false;
	isHead = false;
  generatedPassword: string = '';
  @ViewChild('passwordInput') passwordInput: ElementRef;

  constructor(private userService: UserService,
              private  timeFormatter: TimeFormatterService) {
                this.host = location.origin;
  }

  ngOnInit() {
    this.isAdmin = false;
    this.user = this.userService.getLocal();

    this.userService.getUserFromAPI(this.user.id).subscribe(
      (response) => {
        const data = response.body;
        this.userAPI = data;

        this.userAPI.roles.forEach(role => {
          if (role === 'ADMIN') {
            this.isAdmin = true;
          }
        });

        this.isLoaded = true;
        this.errorInfo = false;

      },
      () => {
        this.isLoaded = true;
        this.errorInfo = true;
      },
      () => {
     
      });

      this.user = this.userService.getLocal();
      if (this.user.roles.indexOf('ROLE_ADMIN') !== -1) {
        this.isAdmins = true;
      } else {
        this.isAdmins = false;
      }
      if (this.user.roles.indexOf('ROLE_HEAD') !== -1) {
        this.isHead = true;
      } else {
        this.isHead = false;
      }
      if (this.user.roles.indexOf('ROLE_USER') !== -1) {
        this.isUser = true;
      } else {
        this.isUser = false;
      }
  }

  generatePassword() {
    const length = 10;
    const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let password = '';
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      password += charset.charAt(randomIndex);
    }
    this.generatedPassword = password;
  }

  copyToClipboard() {
    const textArea = document.createElement('textarea');
    textArea.value = this.generatedPassword;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
  }
}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/my-profile/my-profile.component.ts